import { render, staticRenderFns } from "./ListaDireito.vue?vue&type=template&id=63619214"
import script from "./ListaDireito.vue?vue&type=script&lang=js"
export * from "./ListaDireito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports